import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=611bfb0e&"
import script from "./MainInfo.vue?vue&type=script&lang=ts&"
export * from "./MainInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MainInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports